// extracted by mini-css-extract-plugin
module.exports = {"root":"Count-root-3U172 typography-markerText-1kg8B"};